import { ref, watch } from 'vue'

export function updateComponentKey(props: any, fn?: () => boolean) {
  let componentKey = ref(0)

  watch(
    () => props.model,
    () => {
      if (props.model && (fn === undefined || fn() === true)) {
        componentKey.value += 1
      }
    },
    { immediate: true }
  )

  return componentKey
}
